export enum TimelineGridRootCssVars {
  unitCount = '--unit-count',
  rowCount = '--row-count',
}
